"use strict";
var tooltip_container_component_1 = require('./tooltip/tooltip-container.component');
exports.TooltipContainerComponent = tooltip_container_component_1.TooltipContainerComponent;
var tooltip_directive_1 = require('./tooltip/tooltip.directive');
exports.TooltipDirective = tooltip_directive_1.TooltipDirective;
var tooltip_module_1 = require('./tooltip/tooltip.module');
exports.TooltipModule = tooltip_module_1.TooltipModule;



//////////////////
// WEBPACK FOOTER
// ./~/ng2-bootstrap/components/tooltip.js
// module id = 1008
// module chunks = 1